// Modal.js
import React from "react";
import { useModal } from "./ModalRsuiteContext";
import Modal from "react-bootstrap/Modal";
const IModalRsuit = () => {
  const { isModalOpen, closeModal, modalContent, fullscreen, size, title } =
    useModal();

  if (!isModalOpen) return null;

  return (
    <Modal
      show={isModalOpen}
      onHide={closeModal}
      
      fullscreen={fullscreen}
      size={size}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="text-dark">{title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-dark">{modalContent}</div>
      </Modal.Body>
    </Modal>
  );
};

export default IModalRsuit;
